import React, { useEffect, useState, useCallback, useRef } from 'react';
import Container from '../../Container/Container';
import { useNavigate } from 'react-router';
import { get } from '../../ApiServices/ApiServices';
import Loader from '../Component/Loader';
import CancelFun from '../Component/CancelFun';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useSelector } from 'react-redux';

function SingleOrder() {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [Status, setStatus] = useState([])
    const orderDatePickerRef = useRef(null);
    const eventDatePickerRef = useRef(null);
    const profile = useSelector((state) => state.profile.profile);
    const isAdmin = profile?.name === 'admin' || profile?.name === 'Admin';

    useEffect(() => {
        localStorage.removeItem('coatStyle');
        localStorage.removeItem('size');
        localStorage.removeItem('nonBoldMessage');
        localStorage.removeItem('selectedCoatSize');
        localStorage.removeItem('selectedCategoryName');
        localStorage.removeItem('allSize');
        localStorage.removeItem('Shoes');
        localStorage.removeItem('savedInsleeve');
        localStorage.removeItem('shirtstyle');
        localStorage.removeItem('shirtSizeRecommendationMsg');
        localStorage.removeItem('pantStyle');
        localStorage.removeItem('Tiestyle');

    }, [])


    const [orderDateRange, setOrderDateRange] = useState({
        startDate: null,
        endDate: null,
    });
    const [orderDateDisplayLabel, setOrderDateDisplayLabel] = useState('');

    const [eventDateRange, setEventDateRange] = useState({
        startDate: null,
        endDate: null,
    });
    const [eventDateDisplayLabel, setEventDateDisplayLabel] = useState('');



    const getSingleOrders = useCallback(async (page = 1, limit = 10, searchTerm = '', statusId = '', orderStartDate = null, orderEndDate = null, eventStartDate = null, eventEndDate = null) => {
        setLoading(true);
        try {
            let apiUrl = `all-single-orders?page_number=${page}&size=${limit}`;

            if (searchTerm) apiUrl += `&search=${searchTerm}`;
            if (statusId) apiUrl += `&status_id=${statusId}`;

            if (orderStartDate && orderEndDate) {
                apiUrl += `&order_start_date=${moment(orderStartDate).format('YYYY-MM-DD')}`;
                apiUrl += `&order_end_date=${moment(orderEndDate).format('YYYY-MM-DD')}`;
            }

            if (eventStartDate && eventEndDate) {
                apiUrl += `&start_date=${moment(eventStartDate).format('YYYY-MM-DD')}`;
                apiUrl += `&end_date=${moment(eventEndDate).format('YYYY-MM-DD')}`;
            }

            const response = await get(apiUrl);
            if (response?.status === true) {
                setOrders(response.data.rows);
                setFilteredOrders(response.data.rows);
                setTotalItems(response.data.count || response.data.rows.length);
            } else {
                setOrders([]);
                setFilteredOrders([]);
                setTotalItems(0);
            }
        } catch (err) {
            if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
            console.error('Error fetching orders:', err);
        } finally {
            setLoading(false);
        }
    }, [navigate]);

    // Handle order date range selection
    const handleOrderDateApply = (event, picker) => {
        const startDate = picker.startDate;
        const endDate = picker.endDate;

        setOrderDateRange({ startDate, endDate });
        setOrderDateDisplayLabel(`${startDate.format('MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`);

        // Reset to first page when date changes
        setCurrentPage(1);

        // Fetch data with new date range
        getSingleOrders(
            1,
            itemsPerPage,
            search,
            selectedStatus,
            startDate.format('YYYY-MM-DD'),
            endDate.format('YYYY-MM-DD'),
            eventDateRange.startDate?.format('YYYY-MM-DD'),
            eventDateRange.endDate?.format('YYYY-MM-DD')
        );
    };

    // Clear order date filters - FIXED
    const handleOrderDateCancel = () => {
        setOrderDateRange({ startDate: null, endDate: null });
        setOrderDateDisplayLabel('');

        // Reset to first page and fetch without order date filters
        setCurrentPage(1);
        getSingleOrders(
            1,
            itemsPerPage,
            search,
            selectedStatus,
            null,
            null,
            eventDateRange.startDate?.format('YYYY-MM-DD'),
            eventDateRange.endDate?.format('YYYY-MM-DD')
        );
    };

    // Handle event date range selection
    const handleEventDateApply = (event, picker) => {
        const startDate = picker.startDate;
        const endDate = picker.endDate;

        setEventDateRange({ startDate, endDate });
        setEventDateDisplayLabel(`${startDate.format('MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`);

        // Reset to first page when date changes
        setCurrentPage(1);

        // Fetch data with new date range
        getSingleOrders(
            1,
            itemsPerPage,
            search,
            selectedStatus,
            orderDateRange.startDate?.format('YYYY-MM-DD'),
            orderDateRange.endDate?.format('YYYY-MM-DD'),
            startDate.format('YYYY-MM-DD'),
            endDate.format('YYYY-MM-DD')
        );
    };

    // Clear event date filters - FIXED
    const handleEventDateCancel = () => {
        setEventDateRange({ startDate: null, endDate: null });
        setEventDateDisplayLabel('');

        // Reset to first page and fetch without event date filters
        setCurrentPage(1);
        getSingleOrders(
            1,
            itemsPerPage,
            search,
            selectedStatus,
            orderDateRange.startDate?.format('YYYY-MM-DD'),
            orderDateRange.endDate?.format('YYYY-MM-DD'),
            null,
            null
        );
    };

    // Handle search with debounce
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            getSingleOrders(
                1,
                itemsPerPage,
                search,
                selectedStatus,
                orderDateRange.startDate?.format('YYYY-MM-DD'),
                orderDateRange.endDate?.format('YYYY-MM-DD'),
                eventDateRange.startDate?.format('YYYY-MM-DD'),
                eventDateRange.endDate?.format('YYYY-MM-DD')
            );
            setCurrentPage(1);
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [search, itemsPerPage, selectedStatus, getSingleOrders, orderDateRange, eventDateRange]);

    // Initial load and pagination changes
    useEffect(() => {
        getSingleOrders(
            currentPage,
            itemsPerPage,
            search,
            selectedStatus,
            orderDateRange.startDate?.format('YYYY-MM-DD'),
            orderDateRange.endDate?.format('YYYY-MM-DD'),
            eventDateRange.startDate?.format('YYYY-MM-DD'),
            eventDateRange.endDate?.format('YYYY-MM-DD')
        );
    }, [currentPage, getSingleOrders]);

    const handleSearch = (e) => setSearch(e.target.value);
    const handlePageChange = (page) => setCurrentPage(page);
    const handleItemsPerPageChange = (e) => {
        const newLimit = parseInt(e.target.value);
        setItemsPerPage(newLimit);
        setCurrentPage(1);
    };

    const handleStatusChange = (e) => {
        setSelectedStatus(e.target.value);
        setCurrentPage(1);
    };

    const onCancleSuccess = () => {
        getSingleOrders(
            currentPage,
            itemsPerPage,
            search,
            selectedStatus,
            orderDateRange.startDate?.format('YYYY-MM-DD'),
            orderDateRange.endDate?.format('YYYY-MM-DD'),
            eventDateRange.startDate?.format('YYYY-MM-DD'),
            eventDateRange.endDate?.format('YYYY-MM-DD')
        );
    };

    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const getItemByCategory = (order, categoryName) =>
        order.single_order_style?.find(
            (item) => item.inventory_category?.name === categoryName
        );


    const ActiveStatus = async () => {
        try {
            setLoading(true)
            const api = `get-statuses`;
            const response = await get(api);
            if (response?.message === "success") {
                setStatus(response?.data)
            }
        } catch (err) {
            console.error('Error:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
        }
    };

    useEffect(() => {
        ActiveStatus()
    }, [])

    return (
        <Container>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">Single Orders</h3>
                                    </div>
                                    <div className="nk-block-head-content">
                                        <div className="toggle-wrap nk-block-tools-toggle">
                                            <div className="toggle-expand-content" data-content="pageMenu">
                                                <ul className="nk-block-tools g-3">
                                                    <li className="nk-block-tools-opt">
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => navigate("/add-order", { state: { Helper: true } })}
                                                        >
                                                            <span>Add Single Order</span>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-full WeddingPagesMain">
                                <div className="card-inner">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-control-wrap customrSearch">
                                                <label style={{ fontWeight: 'bold' }}></label>
                                                <div className="form-icon form-icon-right">
                                                    <em className="icon ni ni-search"></em>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search by keywords"
                                                    value={search}
                                                    onChange={handleSearch}
                                                    style={{
                                                        minWidth: '100%',
                                                        border: '1px solid #dbdfea',
                                                        color: '#35495e',
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-control-wrap">
                                                <label style={{ fontWeight: 'bold' }}>
                                                    Event Date
                                                </label>
                                                <DateRangePicker
                                                    ref={orderDatePickerRef}
                                                    initialSettings={{
                                                        startDate: orderDateRange.startDate || moment(),
                                                        endDate: orderDateRange.endDate || moment(),
                                                        locale: {
                                                            format: 'MMM D, YYYY',
                                                            cancelLabel: 'Clear',
                                                            applyLabel: 'Apply',
                                                        },
                                                        ranges: {
                                                            'Today': [moment(), moment()],
                                                            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                                            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                                            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                                                            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                                                        },
                                                        opens: 'right',
                                                        autoApply: true,
                                                        autoUpdateInput: true,
                                                        alwaysShowCalendars: true,
                                                        showCustomRangeLabel: true,
                                                        showCancel: true,
                                                    }}
                                                    onApply={handleOrderDateApply}
                                                    onCancel={handleOrderDateCancel}
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-control order-date-input"
                                                        placeholder="Select date range"
                                                        value={orderDateDisplayLabel}
                                                        readOnly
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: '#fff',
                                                            border: '1px solid #dbdfea',
                                                            borderRadius: '4px',
                                                            padding: '0.375rem 0.75rem',
                                                            minWidth: '100%',
                                                            paddingRight: '30px',
                                                            color: '#35495e',
                                                        }}
                                                    />
                                                </DateRangePicker>
                                                {orderDateDisplayLabel && (
                                                    <span
                                                        className="clear-icon order-date-clear"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            e.preventDefault();
                                                            handleOrderDateCancel();
                                                        }}
                                                        style={{
                                                            position: 'absolute',
                                                            right: '10px',
                                                            top: '70%',
                                                            transform: 'translateY(-50%)',
                                                            cursor: 'pointer',
                                                            zIndex: 10
                                                        }}
                                                    >
                                                        <em className="icon ni ni-cross"></em>
                                                    </span>
                                                )}
                                            </div>
                                        </div>


                                        <div className="col-md-3">
                                            <div className="form-control-wrap">
                                                <label style={{ fontWeight: 'bold' }}>
                                                    Order Date

                                                </label>
                                                <DateRangePicker
                                                    ref={eventDatePickerRef}
                                                    initialSettings={{
                                                        startDate: eventDateRange.startDate || moment(),
                                                        endDate: eventDateRange.endDate || moment(),
                                                        locale: {
                                                            format: 'MMM D, YYYY',
                                                            cancelLabel: 'Clear',
                                                            applyLabel: 'Apply',
                                                        },
                                                        ranges: {
                                                            'Today': [moment(), moment()],
                                                            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                                            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                                            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                                                            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                                                        },
                                                        opens: 'right',
                                                        autoApply: true,
                                                        autoUpdateInput: true,
                                                        alwaysShowCalendars: true,
                                                        showCustomRangeLabel: true,
                                                        showCancel: true,
                                                    }}
                                                    onApply={handleEventDateApply}
                                                    onCancel={handleEventDateCancel}
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-control event-date-input"
                                                        placeholder="Select date range"
                                                        value={eventDateDisplayLabel}
                                                        readOnly
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: '#fff',
                                                            border: '1px solid #dbdfea',
                                                            borderRadius: '4px',
                                                            padding: '0.375rem 0.75rem',
                                                            minWidth: '100%',
                                                            paddingRight: '30px',
                                                            color: '#35495e',
                                                        }}
                                                    />
                                                </DateRangePicker>
                                                {eventDateDisplayLabel && (
                                                    <span
                                                        className="clear-icon event-date-clear"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            e.preventDefault();
                                                            handleEventDateCancel();
                                                        }}
                                                        style={{
                                                            position: 'absolute',
                                                            right: '10px',
                                                            top: '70%',
                                                            transform: 'translateY(-50%)',
                                                            cursor: 'pointer',
                                                            zIndex: 10
                                                        }}
                                                    >
                                                        <em className="icon ni ni-cross"></em>
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-control-wrap">
                                                <label style={{ fontWeight: 'bold' }}>
                                                    Order Status
                                                </label>
                                                <select
                                                    className="form-control"
                                                    value={selectedStatus}
                                                    onChange={handleStatusChange}
                                                    style={{
                                                        minWidth: '100%',
                                                        padding: "12px 16px",
                                                        border: '1px solid #dbdfea',
                                                        color: '#35495e',
                                                        appearance: 'none',
                                                        backgroundImage: "url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%2335495e%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E')",
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundPosition: 'right 0.7rem top 50%',
                                                        backgroundSize: '0.65rem auto',
                                                    }}
                                                >
                                                    <option value="">Filter by Active Status</option>
                                                    <option value="">All</option>
                                                    {
                                                        Status?.map((data) => (
                                                            <option key={data.id} value={data.id}>
                                                                {data?.name}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>


                                    {loading ? (
                                        <Loader />
                                    ) : orders.length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Action</th>
                                                        <th scope="col">Acct</th>
                                                        <th scope="col">Ticket</th>
                                                        <th scope="col">Event Date</th>
                                                        <th scope="col">Customer Name</th>
                                                        <th scope="col">Order Date</th>
                                                        <th scope="col">Order Type</th>
                                                        <th scope="col">School Name</th>
                                                        <th scope="col">Order Status</th>
                                                        <th scope="col">Coat</th>
                                                        <th scope="col">Pant</th>
                                                        <th scope="col">Shirt</th>
                                                        <th scope="col">Vest </th>
                                                        <th scope="col">Tie</th>
                                                        <th scope="col">Shoes</th>
                                                        <th scope="col">Pocket Square</th>
                                                        <th scope="col">Jewelry</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {orders.map((order, index) => {
                                                        const coatItem = getItemByCategory(order, "Coats");
                                                        const shirtItem = getItemByCategory(order, "Shirt");
                                                        const pantsItem = getItemByCategory(order, "Pants");
                                                        const tieItem = getItemByCategory(order, "Ties");
                                                        const jewelryItem = getItemByCategory(order, "Jewelry");
                                                        const vestItem = getItemByCategory(order, "Vests");
                                                        const shoeItem = getItemByCategory(order, "Shoes");
                                                        const pocketSquareItem = getItemByCategory(order, "PocketSquare");

                                                        return (
                                                            <tr key={order.id}>
                                                                <td>
                                                                    <div className="tableActionBtn-1" style={{ cursor: "pointer" }}>
                                                                        <div className="tooltip-container" style={{ position: 'relative', display: 'inline-block' }}>
                                                                            <button
                                                                                className="editPen"
                                                                                onClick={() => {
                                                                                    const disallowedStatuses = ['cancelled', 'pendingCancel', 'cancelRequested', 'pendingChange', 'shipped', 'printed', 'bagged'];
                                                                                    if (!disallowedStatuses.includes(order?.status?.name) &&
                                                                                        (isAdmin || order?.order_type !== "T")) {
                                                                                        navigate(`/update-single-order`, {
                                                                                            state: { ID: order.id, Helper: false }
                                                                                        });
                                                                                    }
                                                                                }}

                                                                                style={(order?.order_type === "T" && !isAdmin) || order?.status?.name == 'cancelled' || order?.status?.name == 'pendingCancel' || order?.status?.name == "pendingChange" || order?.status?.name == "cancelRequested" || order?.status?.name == "shipped" || order?.status?.name == "printed" || order?.status?.name == "bagged" || order?.user?.deletedAt
                                                                                    ? { opacity: 0.5, cursor: 'not-allowed' }
                                                                                    : {}}
                                                                            >
                                                                                <em className="icon ni ni-edit-alt"></em>
                                                                            </button>

                                                                            {order?.user?.deletedAt && (
                                                                                <div
                                                                                    className="tooltip"
                                                                                    style={{
                                                                                        position: 'absolute',
                                                                                        bottom: '100%',
                                                                                        left: '130%',
                                                                                        transform: 'translateX(-50%)',
                                                                                        backgroundColor: '#333',
                                                                                        color: 'white',
                                                                                        padding: '5px 8px',
                                                                                        borderRadius: '4px',
                                                                                        fontSize: '12px',
                                                                                        whiteSpace: 'nowrap',
                                                                                        opacity: 0,
                                                                                        visibility: 'hidden',
                                                                                        transition: 'opacity 0.3s, visibility 0.3s',
                                                                                        zIndex: 1000,
                                                                                        marginBottom: '5px'
                                                                                    }}
                                                                                    onMouseEnter={(e) => {
                                                                                        e.currentTarget.style.opacity = '1';
                                                                                        e.currentTarget.style.visibility = 'visible';
                                                                                    }}
                                                                                    onMouseLeave={(e) => {
                                                                                        e.currentTarget.style.opacity = '0';
                                                                                        e.currentTarget.style.visibility = 'hidden';
                                                                                    }}
                                                                                >
                                                                                    Account removed
                                                                                    <div style={{
                                                                                        position: 'absolute',
                                                                                        top: '100%',
                                                                                        left: '20%',
                                                                                        transform: 'translateX(-50%)',
                                                                                        border: '5px solid transparent',
                                                                                        borderTopColor: '#333'
                                                                                    }}></div>
                                                                                </div>
                                                                            )}

                                                                            <style jsx>{`
        .tooltip-container:hover .tooltip {
            opacity: 1 !important;
            visibility: visible !important;
        }
    `}</style>
                                                                        </div>
                                                                        <button
                                                                            className="deleteTrash"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => navigate('/order-detail', { state: { orderId: order?.id } })}
                                                                        >
                                                                            <em className="icon ni ni-eye"></em>
                                                                        </button>

                                                                        {(isAdmin || order?.order_type !== "T") && !['cancelled', 'pendingCancel', 'cancelRequested', 'pendingChange', 'shipped', 'printed', 'bagged'].includes(order?.status?.name) && (
                                                                            <CancelFun
                                                                                url={`confirm-single-order/${order.id}`}
                                                                                onCancleSuccess={onCancleSuccess}
                                                                                status={order?.status?.name == "ordered" ? 11 : null}
                                                                                requestedByUserId={
                                                                                    profile?.name === "Admin"
                                                                                        ? profile?.id           // Admin cancel
                                                                                        : order?.user_id        // ✅ Customer cancel (198)
                                                                                }
                                                                            />
                                                                        )}

                                                                    </div>
                                                                </td>
                                                                <td>{order?.user?.account || "---"}</td>
                                                                <td>{order?.ticket || "---"}</td>
                                                                <td className="tableMinWidth120">{moment(order?.event_date).format("MMM D, YYYY")}</td>
                                                                <td>{`${order.first_name || ""} ${order.last_name || ""}`.trim() || "---"}</td>
                                                                <td className="tableMinWidth120">{moment.utc(order?.is_csv ? order?.order_creation : order?.createdAt).format("MMM D, YYYY")}</td>
                                                                <td className="tableMinWidth120">{order?.order_type === "T" ? order?.occasion || "---" : order?.order_type || "---"}</td>
                                                                <td>{order?.school || "---"}</td>
                                                                <td style={{ textTransform: 'capitalize' }}>{order?.status?.name || "---"}</td>
                                                                <td data-tooltip-id={`coat-tooltip-${index}`} data-tooltip-content={coatItem?.inventory?.description && `${coatItem?.inventory?.description || ''} , ${coatItem?.size || "Missing size"}${coatItem?.size && coatItem?.size_chart_category?.name
                                                                    ? coatItem.size_chart_category.name === "Short"
                                                                        ? "S"
                                                                        : coatItem.size_chart_category.name === "Long"
                                                                            ? "L"
                                                                            : coatItem.size_chart_category.name === "Extra Long"
                                                                                ? "X"
                                                                                : coatItem.size_chart_category.name === "Regular"
                                                                                    ? "R"
                                                                                    : coatItem.size_chart_category.name === "Boys"
                                                                                        ? "B"
                                                                                        : "N/A"
                                                                    : ""}`} style={{ cursor: "pointer" }}>
                                                                    {coatItem?.style || "---"}
                                                                    <ReactTooltip id={`coat-tooltip-${index}`} />
                                                                </td>
                                                                <td data-tooltip-id={`pants-tooltip-${index}`} data-tooltip-content={pantsItem?.inventory?.description && `${pantsItem?.inventory?.description || ''} , ${pantsItem?.size || "Missing size"}`} style={{ cursor: "pointer" }}>
                                                                    {pantsItem?.style || "---"}
                                                                    <ReactTooltip id={`pants-tooltip-${index}`} />
                                                                </td>
                                                                <td data-tooltip-id={`shirt-tooltip-${index}`} data-tooltip-content={shirtItem?.inventory?.description && `${shirtItem?.inventory?.description || ''} , ${shirtItem?.shirt_size || "Missing size"}`} style={{ cursor: "pointer" }}>
                                                                    {shirtItem?.style || "---"}
                                                                    <ReactTooltip id={`shirt-tooltip-${index}`} />
                                                                </td>
                                                                <td data-tooltip-id={`vest-tooltip-${index}`} data-tooltip-content={vestItem?.inventory?.description && `${vestItem?.inventory?.description || ''} , ${vestItem?.size || "Missing size"}`} style={{ cursor: "pointer" }}>
                                                                    {vestItem?.style || "---"}
                                                                    <ReactTooltip id={`vest-tooltip-${index}`} />
                                                                </td>
                                                                <td data-tooltip-id={`tie-tooltip-${index}`} data-tooltip-content={tieItem?.inventory?.description && `${tieItem?.inventory?.description || ''} , ${order?.order_for || 'Missing size'} `} style={{ cursor: "pointer" }}>
                                                                    {tieItem?.style || "---"}
                                                                    <ReactTooltip id={`tie-tooltip-${index}`} />
                                                                </td>
                                                                <td data-tooltip-id={`shoe-tooltip-${index}`} data-tooltip-content={shoeItem?.inventory?.description && `${shoeItem?.inventory?.description || ''}, ${shoeItem?.inventory?.description ? shoeItem?.size || 'Missing size' : ''}`} style={{ cursor: "pointer" }}>
                                                                    {shoeItem?.style || "---"}
                                                                    <ReactTooltip id={`shoe-tooltip-${index}`} />
                                                                </td>
                                                                <td data-tooltip-id="pocket-square-tooltip" data-tooltip-content={pocketSquareItem?.inventory?.description || ''} style={{ cursor: "pointer" }}>
                                                                    {pocketSquareItem?.style || "---"}
                                                                    <ReactTooltip id="pocket-square-tooltip" />
                                                                </td>
                                                                <td data-tooltip-id="jewelry-tooltip" data-tooltip-content={jewelryItem?.inventory?.description || ''} style={{ cursor: "pointer" }}>
                                                                    {jewelryItem?.style || "---"}
                                                                    <ReactTooltip id="jewelry-tooltip" />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="text-center">No data available</div>
                                    )}

                                    {/* Pagination */}
                                    {filteredOrders.length > 0 && (
                                        <div className="nk-block-between-md g-3 mt-3">
                                            <div className="g">
                                                <div className="pagination d-flex gap-2" style={{ height: "35px" }}>
                                                    <button
                                                        className={`btn btn-sm ${currentPage === 1 ? 'btn-disabled' : 'btn-primary'}`}
                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                        disabled={currentPage === 1}
                                                    >
                                                        Previous
                                                    </button>

                                                    {Array.from({ length: totalPages }, (_, i) => (
                                                        <button
                                                            key={i + 1}
                                                            className={`btn btn-sm ${currentPage === i + 1 ? 'btn-primary' : 'btn-outline-primary'}`}
                                                            onClick={() => handlePageChange(i + 1)}
                                                        >
                                                            {i + 1}
                                                        </button>
                                                    )).slice(
                                                        Math.max(0, currentPage - 3),
                                                        Math.min(currentPage + 2, totalPages)
                                                    )}

                                                    <button
                                                        className={`btn btn-sm ${currentPage === totalPages ? 'btn-disabled' : 'btn-primary'}`}
                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            </div>

                                            {filteredOrders.length >= 10 && (
                                                <div className="g">
                                                    <div className="pagination-goto d-flex justify-content-center justify-content-md-start gx-3">
                                                        <div>Showing</div>
                                                        <div>
                                                            <select
                                                                className="form-select js-select2"
                                                                value={itemsPerPage}
                                                                onChange={handleItemsPerPageChange}
                                                            >
                                                                {totalItems >= 10 && <option value="10">10</option>}
                                                                {totalItems >= 20 && <option value="20">20</option>}
                                                                {totalItems >= 50 && <option value="50">50</option>}
                                                                {totalItems >= 100 && <option value="100">100</option>}
                                                            </select>
                                                        </div>
                                                        <div>of {totalItems} items</div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default SingleOrder;